import * as React from 'react';
import { noop } from 'underscore';
import { SegmentedVideoPlayerInstance } from 'components/SegmentedVideoPlayer/types';
import WorkspacePositionOverlay from 'components/WorkspacePositionOverlay';
import MediaSegmentVideoPlayer from 'containers/MediaSegmentVideoPlayer';
import { VideoCropperVideoRef, VideoProps } from '../types';
import {
  block,
  getScaledVideoDimensions,
  getVideoContainerStyles,
  getVideoStyles,
} from '../utils';
import DragHandle from './DragHandle';

export default class DraggableVideo extends React.Component<VideoProps> {
  public static defaultProps: Partial<VideoProps> = {
    onPause: noop,
    onPlay: noop,
    videoRef: noop,
  };

  private video: VideoCropperVideoRef;

  public UNSAFE_componentWillReceiveProps(nextProps: Readonly<VideoProps>) {
    const { playing, seekToSec } = this.props;
    const {
      onPause,
      onPlay,
      playing: nextPlaying,
      seekToSec: nextSeekToSec,
    } = nextProps;

    if (playing && !nextPlaying) {
      this.video.pause();
      onPause();
    }

    if (!playing && nextPlaying) {
      this.video.play().then(onPlay);
    }

    if (nextSeekToSec && nextSeekToSec !== seekToSec) {
      this.video.currentTime = nextSeekToSec;
    }
  }

  private setVideoRefs = (el: SegmentedVideoPlayerInstance) => {
    const { videoRef, mediaRef } = this.props;
    this.video = el;

    videoRef(el);
    mediaRef && mediaRef(el);
  };

  public render() {
    const {
      src,
      top,
      left,
      defaultPosition,
      cropInfo,
      videoFileSize,
      cropMetadata,
      dragging,
      boundingBox,
      onDragStart,
      onDragStop,
      onDrag,
      mediaSegmentInfoId,
    } = this.props;

    const { dimension } = cropInfo ?? {};

    const scaledVideoDimensions = getScaledVideoDimensions(
      videoFileSize,
      dimension,
      cropMetadata,
      boundingBox,
    );

    return (
      <div>
        <DragHandle
          cropInfo={{
            ...cropInfo,
            dimension: scaledVideoDimensions?.width
              ? scaledVideoDimensions
              : dimension,
          }}
          onDragStart={onDragStart}
          onDrag={onDrag}
          onDragStop={onDragStop}
          top={top}
          left={left}
          dragging={dragging}
        />
        <div
          className={block('video-container')}
          style={{
            ...getVideoContainerStyles(
              top,
              left,
              scaledVideoDimensions,
              boundingBox,
            ),
          }}
        >
          <MediaSegmentVideoPlayer
            className={block('video')}
            mediaSegmentDataId={mediaSegmentInfoId}
            ref={this.setVideoRefs}
            src={src}
            style={{
              ...(boundingBox
                ? getVideoStyles(boundingBox)
                : {
                    ...dimension,
                    top,
                    left,
                  }),
            }}
          />

          <WorkspacePositionOverlay
            className={block('position-overlay')}
            display
            position={{
              x: left ?? defaultPosition.left,
              y: top ?? defaultPosition.top,
            }}
          />
        </div>
      </div>
    );
  }
}
